module.exports = __webpack_public_path__ + "img/s10-bg.fb39e67e.jpg";